(() => {
  if (customElements.get('caseere-sticky-product-bar')) return;

  const activeClass = 'caseere-sticky-product-bar-active';
  const ensureRuntimeStyles = () => {
    if (document.querySelector('[data-caseere-sticky-product-bar-runtime-style]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-caseere-sticky-product-bar-runtime-style', '');
    style.textContent = `
      .caseere-sticky-product-bar { opacity: 1 !important; pointer-events: auto !important; transform: translateY(0) !important; }
      .caseere-sticky-product-bar__payment { align-items: stretch !important; display: flex !important; }
      .caseere-sticky-product-bar__payment .shopify-payment-button,
      .caseere-sticky-product-bar__payment shopify-accelerated-checkout,
      .caseere-sticky-product-bar__payment shopify-accelerated-checkout-cart { display: block !important; height: 100% !important; width: 100% !important; }
      .caseere-sticky-product-bar__payment .shopify-payment-button__more-options { display: none !important; }
      @media (max-width: 991px) {
        .caseere-sticky-product-bar__summary { display: none !important; }
        .caseere-sticky-product-bar__controls { display: grid !important; grid-template-columns: minmax(0, 1fr) 104px minmax(118px, 136px) !important; gap: 12px !important; }
        .caseere-sticky-product-bar__variant,
        .caseere-sticky-product-bar__quantity,
        .caseere-sticky-product-bar__add { height: 48px !important; }
        .caseere-sticky-product-bar__quantity { display: grid !important; grid-template-columns: 32px 40px 32px !important; }
        .caseere-sticky-product-bar .caseere-sticky-product-bar__payment { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  };

  customElements.define('caseere-sticky-product-bar', class extends HTMLElement {
    connectedCallback() {
      ensureRuntimeStyles();
      this.form = this.querySelector('form');
      this.mainForm = document.getElementById(this.dataset.mainFormId || '');
      this.variantInput = this.querySelector('[data-caseere-sticky-variant-id]');
      this.variantSelect = this.querySelector('[data-caseere-sticky-variant-select]');
      this.priceNode = this.querySelector('[data-caseere-sticky-price]');
      this.compareNode = this.querySelector('[data-caseere-sticky-compare]');
      this.imageNode = this.querySelector('[data-caseere-sticky-image]');
      this.qtyInput = this.querySelector('[data-caseere-sticky-qty-input]');
      this.minusButton = this.querySelector('[data-caseere-sticky-qty-minus]');
      this.plusButton = this.querySelector('[data-caseere-sticky-qty-plus]');
      this.addButton = this.querySelector('[data-add-button]');
      this.soldOutButton = this.querySelector('[data-sold-out-button]');
      this.paymentButton = this.querySelector('[data-buy-button]');

      this._bindVariant();
      this._bindQuantity();
      this._bindVisibility();
      this._applySelectedVariant();
      this._syncQuantityButtons();
      this._updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._visibilityHandler);
      window.removeEventListener('resize', this._visibilityHandler);
      if (document.body.classList.contains(activeClass)) {
        document.body.classList.remove(activeClass);
      }
    }

    _bindVariant() {
      if (!this.variantSelect || this.variantSelect.dataset.caseereBound === 'true') return;
      this.variantSelect.dataset.caseereBound = 'true';
      this.variantSelect.addEventListener('change', () => this._applySelectedVariant());
    }

    _applySelectedVariant() {
      if (!this.variantSelect) return;
      const option = this.variantSelect.options[this.variantSelect.selectedIndex];
      if (!option) return;

      if (this.variantInput) {
        this.variantInput.value = option.value;
      }
      if (this.priceNode && option.dataset.price) {
        this.priceNode.textContent = option.dataset.price;
      }
      if (this.compareNode) {
        this.compareNode.textContent = option.dataset.compare || '';
        this.compareNode.toggleAttribute('hidden', !option.dataset.compare);
      }
      if (this.imageNode && option.dataset.image) {
        this.imageNode.src = option.dataset.image;
      }

      const available = option.dataset.available !== 'false';
      if (this.addButton) {
        this.addButton.toggleAttribute('disabled', !available);
        this.addButton.toggleAttribute('hidden', !available);
      }
      if (this.soldOutButton) {
        this.soldOutButton.toggleAttribute('hidden', available);
      }
      if (this.paymentButton) {
        this.paymentButton.toggleAttribute('hidden', !available);
      }
    }

    _bindQuantity() {
      if (!this.qtyInput || this.qtyInput.dataset.caseereBound === 'true') return;
      this.qtyInput.dataset.caseereBound = 'true';

      this.minusButton?.addEventListener('click', () => this._changeQuantity(-1));
      this.plusButton?.addEventListener('click', () => this._changeQuantity(1));
      this.qtyInput.addEventListener('change', () => this._normalizeQuantity());
      this.qtyInput.addEventListener('input', () => this._syncQuantityButtons());
    }

    _changeQuantity(amount) {
      const current = this._quantityValue();
      this.qtyInput.value = String(Math.max(1, current + amount));
      this._syncQuantityButtons();
    }

    _normalizeQuantity() {
      this.qtyInput.value = String(this._quantityValue());
      this._syncQuantityButtons();
    }

    _quantityValue() {
      const value = Number.parseInt(this.qtyInput?.value || '1', 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    _syncQuantityButtons() {
      if (this.minusButton) {
        this.minusButton.toggleAttribute('disabled', this._quantityValue() <= 1);
      }
    }

    _bindVisibility() {
      if (this._visibilityHandler) return;
      this._visibilityHandler = () => this._updateVisibility();
      window.addEventListener('resize', this._visibilityHandler);
      window.setTimeout(this._visibilityHandler, 80);
    }

    _updateVisibility() {
      const shouldShow = this._shouldShow();
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle(activeClass, shouldShow);
      if (shouldShow) {
        document.documentElement.style.setProperty('--caseere-sticky-product-bar-height', `${this.offsetHeight}px`);
      }
    }

    _shouldShow() {
      return true;
    }
  });
})();
